import React, { useReducer } from 'react';
import get from 'lodash/get';
import axios from 'axios';
import { useQueryParams } from '../../hooks';
import { useTranslation } from 'react-i18next';
import '../../translations/i18n';
import style from './style.module.css';
import config from '../../utilities/Config';
import { useForm } from 'react-hook-form';
import { Button, Grid, TextField } from '@mui/material';

const EmailValidation = () => {
    const email = useQueryParams().get('email');
    const token = useQueryParams().get('token');
    const recoveryEndpoint = config.get('recovery.url');
    const { t } = useTranslation();
    const [{ message, completed }, dispatch] = useReducer((state, action) => {
        return { ...state, ...action };
    }, { message: '', completed: false });

    const onSuccess = (response) => {
        const message = { type: MessageType.Success, description: t('passwordRecovery.completed') };
        dispatch({ completed: true, message: message });
        return;
    };

    const onSubmit = ({ newPassword }, e) => {
        axios.post(recoveryEndpoint,
        {
            userName: email,
            token: token,
            password: newPassword
        })
        .then(onSuccess)
        .catch(onFailure);
    }

    const onFailure = (e) => {
        const statusCode = get(e, 'response.data.statusCode');
        console.log(e);
        // Missing Request  
        if (statusCode === "AUTH007") {
            const message = { type: MessageType.Failure, description: t('passwordRecovery.error.invalid') };
            dispatch({ completed: true, message: message });
            return;
        }

        // Expired Request  
        if (statusCode === "AUTH008") {
            const message = { type: MessageType.Failure, description: t('passwordRecovery.error.expired') };
            dispatch({ completed: true, message: message });
            return;
        }

        // Invalid Request  
        if (statusCode === "AUTH009") {
            const message = { type: MessageType.Failure, description: t('passwordRecovery.error.invalid') };
            dispatch({ completed: true, message: message });
            return;
        }

        const message = { type: MessageType.Failure, description: t('passwordRecovery.error.unknown') };
        dispatch({ completed: true, message: message });
    };

    return (
        <React.Fragment>
            <div style={{ fontSize: '24px', padding: '15px', backgroundColor: '#EEE', textAlign: 'left' }}>
                Password Recovery
            </div>
            {!completed &&
                <PasswordChangeForm email={email} onSubmit={onSubmit} />
            }
            {completed &&
                <div className={style.statusPnl}>
                    <div className={style.statusBox}>
                        <div className={style.statusText}>{message.description}</div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}

const PasswordChangeForm = ({email, onSubmit}) => {

    const {
        register,
        formState: { errors },
        getValues,
        handleSubmit
    } = useForm();

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="App" style={{ display: 'flex', flexDirection: 'column', padding: '15px', justtifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '300px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    id="emailAddress"
                                    label="Email Address"
                                    variant="standard"
                                    value={email}
                                    fullWidth
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="newPassword"
                                    label="New Password"
                                    variant="standard"
                                    fullWidth
                                    error={errors.newPassword != null}
                                    helperText={errors.newPassword && errors.newPassword.message}
                                    {...register("newPassword", { required: "Password is required!" })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="confirmPassword"
                                    label="Confirm Password"
                                    variant="standard"
                                    fullWidth
                                    error={errors.confirmPassword != null}
                                    helperText={errors.confirmPassword && errors.confirmPassword.message}
                                    {...register("confirmPassword", {
                                        required: "Please confirm password!",
                                        validate: {
                                            matchesPreviousPassword: (value) => {
                                                const { newPassword } = getValues();
                                                return newPassword === value || "Passwords should match!";
                                            }
                                        }
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '15px' }}>
                                    <Button type="submit" variant="contained">Save Changes</Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </form>
        </div>
    );
}

const MessageType = { Success: 'S', Error: 'E' };

export default EmailValidation;

